import { render, staticRenderFns } from "./CityManagerList.vue?vue&type=template&id=b5807c7a&scoped=true"
import script from "./CityManagerList.vue?vue&type=script&lang=js"
export * from "./CityManagerList.vue?vue&type=script&lang=js"
import style0 from "./CityManagerList.vue?vue&type=style&index=0&id=b5807c7a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5807c7a",
  null
  
)

export default component.exports